import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type CreateStageTemplateInput,
	createStageTemplate,
} from "@/adapters/api";

export function useCreateStageTemplate() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: CreateStageTemplateInput) => createStageTemplate(input),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["stage-templates"] });
		},
	});
}
